// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + (chunkId === 876 ? "CashierExpressCheckoutWidget" : chunkId) + ".chunk.min.js";
};